import { useCallback } from 'react';
import { useIntl } from 'react-intl';

import { LocalizedMessageId } from '../types';

type PrimitiveType = string | number | boolean | null | undefined | Date;

export type FormatMessage = (
  id: LocalizedMessageId,
  values?: Record<string, PrimitiveType | ((parts: Array<string>) => string)>,
  defaultMessage?: string,
) => string;

export function useFormatMessage(): FormatMessage {
  const { formatMessage } = useIntl();
  return useCallback(
    (id, values, defaultMessage) => {
      if (!id) return '';
      return formatMessage({ id, defaultMessage }, values);
    },
    [formatMessage],
  );
}
